<div class="chat-view-container">
  <app-header (toggleClick)="toggleSidebar()" (zoomInClick)="onZoomIn()" (zoomOutClick)="onZoomOut()" (refreshClick)="onRefreshChat()"
    [codingModeAvailable]="!!selectedPromptId" [codingMode]="codingMode" (codingModeToggle)="toggleCodingMode()"
    class="header"></app-header>
  <!-- <button class="sidebar-toggle-btn" (click)="toggleSidebar()" aria-label="Toggle sidebar">
    <mat-icon style="color: #fff;">{{ sidebarOpened ? 'arrow_back_ios' : 'arrow_forward_ios' }}</mat-icon>
  </button> -->

  <div class="main-layout" [class.shifted]="sidebarOpened">
    <app-sidebar (selectedPromptId)="onPromptSelected($event)" [class.closed]="!sidebarOpened"
      class="sidebar"></app-sidebar>
    <div class="message-flow-container">
      <!-- Diff view always enabled - no toggle needed -->
      
      <!-- <div class="ai-key-status" *ngIf="aiKeyStatuses && aiKeyStatuses.length"
        style="display:flex;align-items:center;padding:6px 12px;font-size:13px;border-radius:6px;margin:8px 12px;">
        <mat-icon [style.color]="isAiKeyHealthy() ? '#43a047' : '#e53935'">{{ isAiKeyHealthy() ? 'lock' : 'error' }}</mat-icon>
        <span style="margin-left:8px">{{ aiKeyOverallStatusText }}</span>
      </div> -->
      <!-- Optional chat window header -->
      <!-- <div class="chat-window-header">
           ...
      </div> --> 

      <div class="chat-messages-container" #scrollContainer #zoomContainer (scroll)="onScroll()">
        <div *ngIf="!(currentConversation$ | async) || (currentConversation$ | async)?.messages?.length === 0" class="empty-chat-state">
          <mat-icon class="empty-chat-icon">chat_bubble_outline</mat-icon>
          <p class="empty-chat-text">No chat history yet</p>
          <p class="empty-chat-hint">Start a conversation by typing a message below</p>
        </div>
        <div *ngFor="let msg of (currentConversation$ | async)?.messages; trackBy: trackByMessage"
          class="message-wrapper" [ngClass]="msg.sender">
          <div class="message-card">
            <div class="message-header">
              <mat-icon class="chat-icon">{{ msg.sender === 'bot' ? 'chat' : 'group' }}</mat-icon>
              <p class="sender-label">{{ msg.sender === 'bot' ? 'Otter AI' : 'You' }}</p>
              <p class="msg-time">{{ msg.timestamp | date : "MMM d, y, h:mm a" }}</p>
              <mat-icon class="mat-icon-copy" [class.animate-copied]="msg.copied" (click)="copyToClipboard(msg)"
                matTooltip="{{ msg.copied ? 'Copied!' : 'Copy link' }}">
                {{ msg.copied ? 'check_circle' : 'content_copy' }}
              </mat-icon>
            </div>
            <div class="message-body mb-2">
              <ng-container *ngIf="msg.text === '...' || msg.text === '__LOADER__'; else normalMsg">
                <span class="bot-loader-spinner">
                  <mat-progress-spinner diameter="22" mode="indeterminate" color="primary"
                    strokeWidth="4"></mat-progress-spinner>
                  <span class="loading-text"></span>
                </span>
              </ng-container>
              <!-- scroll-to-bottom button removed from message body and placed over the input for better UX -->
              <ng-template #normalMsg>
                <app-coding-answer *ngIf="isCodingAnswer(msg.text); else markdownMsg" [text]="msg.text"></app-coding-answer>
                <ng-template #markdownMsg>
                  <span [innerHTML]="formatMessage(msg.text, msg)"></span>
                </ng-template>
              </ng-template>

            </div>

          </div>
        </div>
      </div>

      <div class="chat-input-container">
        <form class="chat-input-form" (ngSubmit)="sendMessage()">
          <!-- Scroll to bottom floating button -->
          <div class="floating-actions">
            <button type="button" class="floating-btn scroll-btn" *ngIf="!isNearBottom"
              (click)="scrollToBottom(true)" aria-label="Scroll to bottom" title="Scroll to bottom">
              <mat-icon>arrow_downward</mat-icon>
            </button>
          </div>
          <!-- Always-visible coach cue bar — horizontal scroll tiles -->
          <div class="coach-cue-bar">
            <div class="coach-cue-scroll">
              <ng-container *ngFor="let cat of coachCueCategories">
                <button *ngFor="let cue of cat.cues" type="button" class="cue-tile"
                  [class.clicked]="clickedCueLabel === cue.label"
                  [style.--tile-bg]="cue.bg"
                  (click)="sendCoachCue(cue)" [title]="cue.fullLabel || cue.label">
                  <span *ngIf="cue.svgKey" class="cue-tile-svg" [innerHTML]="getSvgHtml(cue.svgKey)"></span>
                  <span *ngIf="!cue.svgKey" class="cue-tile-emoji">{{ cue.emoji }}</span>
                  <span class="cue-tile-label">{{ cue.label }}</span>
                </button>
              </ng-container>
            </div>
          </div>
          <div class="upper-textarea-row" *ngIf="showScratchpad">
            <div class="scratchpad-label-row">
              <label class="upper-textarea-label">Scratchpad</label>
              <span class="scratchpad-close-btn" (click)="showScratchpad = false" title="Close scratchpad">
                <mat-icon>close</mat-icon>
              </span>
            </div>
            <textarea #upperTextarea [(ngModel)]="upperText" name="upperText" class="upper-textarea-content" rows="3"
              placeholder="Add or edit your scratchpad text here..."></textarea>
          </div>
          <div class="input-row" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
            <textarea #input [(ngModel)]="userInput" name="messageInput"
              [placeholder]="codingMode ? 'Ask a coding question, attach a screenshot of the problem or code, or describe a change...' : 'Type your message here...'"
              autocomplete="off" (keydown)="onInputKeydown($event)" (paste)="onPaste($event)" rows="4" class="chat-textarea"></textarea>
            <div class="actions">
              <button type="button" class="circle-btn mic-btn" [class.recording]="isMicOn" (click)="toggleMic()"
                title="{{ isMicOn ? 'Stop Recording' : 'Start Recording' }}">
                <mat-icon>{{ isMicOn ? 'mic' : 'mic_off' }}</mat-icon>
              </button>
              <button type="button" class="circle-btn up-arrow-btn" (click)="moveInputToUpper()"
                [disabled]="!userInput.trim()" title="Move to upper text area">
                <mat-icon>north</mat-icon>
              </button>
              <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*,.pdf,.doc,.docx,.txt"
                style="display:none" />
              <button type="button" class="circle-btn attach-btn" (click)="fileInput.click()"
                title="Attach a file or image">
                <mat-icon>attach_file</mat-icon>
              </button>
              <!-- Single button: stop while streaming, send when idle -->
              <button *ngIf="isStreaming" type="button" class="circle-btn" (click)="stopStreaming()" title="Stop streaming">
                <mat-icon>stop</mat-icon>
              </button>
              <button *ngIf="!isStreaming" type="submit" class="circle-btn"
                [disabled]="isUploadingAttachment || (!userInput.trim() && !upperText && !(codingMode && s3FileUrl))" title="Send">
                <mat-icon>send</mat-icon>
              </button>
            </div>

            <div *ngIf="s3FileUrl || isUploadingAttachment" class="attachment-preview-gpt">
              <div class="attachment-card-gpt">
                <ng-container *ngIf="isUploadingAttachment">
                  <mat-icon class="gpt-icon">hourglass_top</mat-icon>
                  <span class="gpt-label">Uploading...</span>
                  <mat-progress-spinner diameter="18" mode="indeterminate" color="primary"
                    class="gpt-spinner"></mat-progress-spinner>
                </ng-container>
                <ng-container *ngIf="!isUploadingAttachment && s3FileUrl">
                  <mat-icon class="gpt-icon">{{ s3FileType === 'image' ? 'image' : 'insert_drive_file' }}</mat-icon>
                  <span class="gpt-label">
                    {{ s3FileType === 'image' ? 'Image attached' : 'File attached' }}
                  </span>
                  <span class="gpt-filename" *ngIf="attachedFileName">{{ attachedFileName }}</span>
                  <mat-icon style="color: #e53935;"
                    (click)="s3FileUrl = ''; s3FileType = ''; attachedFileName = ''">close</mat-icon>
                </ng-container>
              </div>
            </div>

            <div *ngIf="fileTypeError" class="file-type-error-gpt">
              <mat-icon style="color:#e53935;margin-right:4px;">error_outline</mat-icon>
              <span>{{ fileTypeError }}</span>
            </div>
          </div>
        </form>
      </div>

      <div class="zoom-indicator" *ngIf="showZoomIndicator" title="Click to reset zoom" style="position: absolute; top: 8px; right: 16px; 
              background: rgba(0,0,0,0.7); color: white; 
              padding: 6px 12px; border-radius: 6px; cursor: pointer; user-select: none; z-index: 1000;">
        Zoom: {{ zoomDisplayValue }}
      </div>
    </div>
  </div>
